module.exports = __webpack_public_path__ + "media/images/church-da148a2bd3396c2ae2805679183106f8.jpeg";